const woodSpecies = [
  { woodSpecies: ['Acacia'] },
  { woodSpecies: ['Ash'] },
  { woodSpecies: ['Beech'] },
  { woodSpecies: ['Birch'] },
  { woodSpecies: ['Bubinga'] },
  { woodSpecies: ['Cherry'] },
  { woodSpecies: ['Jatoba'] },
  { woodSpecies: ['Kapur'] },
  { woodSpecies: ['Leopardwood'] },
  { woodSpecies: ['Mahogany'] },
  { woodSpecies: ['Mango'] },
  { woodSpecies: ['Maple'] },
  { woodSpecies: ['Oak'] },
  { woodSpecies: ['Padauk'] },
  { woodSpecies: ['Poplar'] },
  { woodSpecies: ['Purpleheart'] },
  { woodSpecies: ['Sapele'] },
  { woodSpecies: ['Walnut'] },
  { woodSpecies: ['Wenge'] },
];

export default woodSpecies;